import angular from 'angular';
import ExpenseGridModal from './expenseGridModal';

export default angular
  .module('components.expenseGridModal', [])
  .component('expenseGridModal', ExpenseGridModal).name;
